import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { emailtemplateService } from "../../_services/emailTemplate.service";
import StandardAutoComplete from "./standard.autocomplete";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
    parentId: number
}

export const EmailTemplateAutoComplete = (params: IStandardExtAutocomplete) => {

    function fetchItems() {
        return emailtemplateService
            .dropdown(params.parentId);
    }

    return (
        <StandardAutoComplete
            {...params}
            itemsLoader={fetchItems}
            label={"Email Template"} />
    );
}